import { Cloud, ExternalLink } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
const Proveedores = ({ isDarkMode }) => {
    const { language, translations } = useLanguage();
    const proveedores = translations[language].proveedores;
  const providers = [
    {
      name: proveedores.proveedores[0].name,
      service: proveedores.proveedores[0].service,
      url: proveedores.proveedores[0].url,
      logo: (
        <div className="w-full h-full bg-gradient-to-br from-red-500 to-orange-500 rounded flex items-center justify-center">
          <span className="text-white font-bold text-lg">SERED</span>
        </div>
      ),
      description: proveedores.proveedores[0].description,
    },
    {
      name: proveedores.proveedores[1].name,
      service: proveedores.proveedores[1].service,
      url: proveedores.proveedores[1].url,
      logo: (
        <div className="w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 rounded flex items-center justify-center">
          <span className="text-white font-bold text-[12px]">CONTABO</span>
        </div>
      ),
      description: proveedores.proveedores[1].description,
    },
    {
      name: proveedores.proveedores[2].name,
      service: proveedores.proveedores[2].service,
      url: proveedores.proveedores[2].url,
      logo: (
        <div className="w-full h-full bg-gradient-to-br from-orange-500 to-yellow-600 rounded flex items-center justify-center">
          <span className="text-white font-bold text-lg">AWS</span>
        </div>
      ),
      description: proveedores.proveedores[2].description,
    },
  ];

  return (
    <div className="container mx-auto px-4 mb-16 mt-16 py-50">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 rounded-full mb-4">
          <Cloud size={20} className="text-purple-500" />
          <span className="text-sm font-medium text-purple-500">
            {proveedores.titulos.infraestructuraConfianza}
          </span>
        </div>

        <h3
          className={`text-2xl font-bold mb-3 ${
            isDarkMode ? "text-white" : "text-gray-900"
          }`}
        >
          {proveedores.titulos.proveedoresInfraestructura}
        </h3>

        <p
          className={`text-lg max-w-2xl mx-auto ${
            isDarkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          {proveedores.textos.descripcion}
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {providers.map((provider, index) => (
          <a
            key={index}
            href={provider.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`group relative overflow-hidden rounded-xl transition-all duration-300 hover:transform hover:-translate-y-2 ${
              isDarkMode
                ? "bg-gradient-to-br from-gray-800 to-gray-900 hover:shadow-2xl hover:shadow-purple-500/20"
                : "bg-white shadow-lg hover:shadow-2xl"
            }`}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            <div className="relative p-6">
              <div className="flex items-start gap-4">
                <div className="w-16 h-16 flex-shrink-0 transform group-hover:scale-110 transition-transform duration-300">
                  {provider.logo}
                </div>
                <div className="flex-1">
                  <h4
                    className={`font-bold text-lg mb-1 ${
                      isDarkMode ? "text-white" : "text-gray-900"
                    }`}
                  >
                    {provider.name}
                  </h4>
                  <p className="text-purple-500 text-sm font-medium mb-2">
                    {provider.service}
                  </p>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-500" : "text-gray-600"
                    }`}
                  >
                    {provider.description}
                  </p>
                </div>
              </div>

              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <ExternalLink size={16} className="text-purple-500" />
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
  /*   const providers = [
    {
      name: "Sered",
      service: "Dominios & Email",
      url: "https://sered.net",
      logo: (
        <div className="w-full h-full bg-gradient-to-br from-red-500 to-orange-500 rounded flex items-center justify-center">
          <span className="text-white font-bold text-lg">SERED</span>
        </div>
      ),
      description: "Gestión profesional de dominios y correo corporativo",
    },
    {
      name: "Contabo",
      service: "Servidores VPS",
      url: "https://contabo.com",
      logo: (
        <div className="w-full h-full bg-gradient-to-br from-blue-600 to-blue-800 rounded flex items-center justify-center">
          <span className="text-white font-bold text-[12px]">CONTABO</span>
        </div>
      ),
      description: "Infraestructura VPS de alto rendimiento",
    },
    {
      name: "Amazon AWS",
      service: "Cloud Computing",
      url: "https://aws.amazon.com",
      logo: (
        <div className="w-full h-full bg-gradient-to-br from-orange-500 to-yellow-600 rounded flex items-center justify-center">
          <span className="text-white font-bold text-lg">AWS</span>
        </div>
      ),
      description: "Despliegue escalable en la nube",
    },
  ];

  return (
    <div className="container mx-auto px-4 mb-16 mt-16 py-50">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 rounded-full mb-4">
          <Cloud size={20} className="text-purple-500" />
          <span className="text-sm font-medium text-purple-500">
            Infraestructura de Confianza
          </span>
        </div>

        <h3
          className={`text-2xl font-bold mb-3 ${
            isDarkMode ? "text-white" : "text-gray-900"
          }`}
        >
          Proveedores de Infraestructura
        </h3>

        <p
          className={`text-lg max-w-2xl mx-auto ${
            isDarkMode ? "text-gray-400" : "text-gray-600"
          }`}
        >
          Trabajamos con los mejores proveedores para garantizar la máxima
          disponibilidad y rendimiento
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {providers.map((provider, index) => (
          <a
            key={index}
            href={provider.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`group relative overflow-hidden rounded-xl transition-all duration-300 hover:transform hover:-translate-y-2 ${
              isDarkMode
                ? "bg-gradient-to-br from-gray-800 to-gray-900 hover:shadow-2xl hover:shadow-purple-500/20"
                : "bg-white shadow-lg hover:shadow-2xl"
            }`}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            <div className="relative p-6">
              <div className="flex items-start gap-4">
                <div className="w-16 h-16 flex-shrink-0 transform group-hover:scale-110 transition-transform duration-300">
                  {provider.logo}
                </div>
                <div className="flex-1">
                  <h4
                    className={`font-bold text-lg mb-1 ${
                      isDarkMode ? "text-white" : "text-gray-900"
                    }`}
                  >
                    {provider.name}
                  </h4>
                  <p className="text-purple-500 text-sm font-medium mb-2">
                    {provider.service}
                  </p>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-500" : "text-gray-600"
                    }`}
                  >
                    {provider.description}
                  </p>
                </div>
              </div>

              <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <ExternalLink size={16} className="text-purple-500" />
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  ); */
};

export default Proveedores;
